import { Grid } from '@mui/material';
import { CustomTextField } from '../../../components/CustomTextField';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const ShapeProperties = ({
    selectedShape,
    shapeHeight,
    shapeWidth,
    shapeHorizontal,
    shapeVertical,
    shapeCornerRadius,
    shapeRadius,
    shapeStrokeWidth,
    fontSize,
    handleChangeProperty,
    t,
}) => {
    return (
        <div className='mt-3'>
            {selectedShape !== null && <h4 className='mb-3 title-property'>{t('position')}</h4>}

            {(selectedShape?.property === 'squares' ||
                selectedShape?.property === 'texts' ||
                selectedShape?.property === 'lines') && (
                <Grid item xs={6} md={6}>
                    <div className='d-flex align-items-center'>
                        <CustomTextField
                            id='txt_sp_height'
                            name='shapeHeight'
                            trans='height'
                            value={shapeHeight}
                            type='number'
                            disabled={
                                selectedShape?.property !== 'squares' &&
                                selectedShape?.property !== 'texts' &&
                                selectedShape?.property !== 'lines'
                            }
                            onChange={(e) => {
                                const max = 460;
                                let newValue = Number(e.target.value);
                                if (max && newValue > max) {
                                    newValue = max;
                                }
                                handleChangeProperty('height', newValue);
                            }}
                            showCounter={false}
                        />
                    </div>
                </Grid>
            )}
            {selectedShape?.property === 'texts' && (
                <Grid item xs={6} md={6}>
                    <div className='d-flex align-items-center'>
                        <CustomTextField
                            id='txt_sp_font_size'
                            name='fontSize'
                            trans='font_size'
                            type='number'
                            value={fontSize}
                            disabled={
                                selectedShape?.property !== 'squares' &&
                                selectedShape?.property !== 'texts' &&
                                selectedShape?.property !== 'lines'
                            }
                            onChange={(e) => {
                                const max = 460;
                                let newValue = Number(e.target.value);
                                if (max && newValue > max) {
                                    newValue = max;
                                }
                                handleChangeProperty('fontSize', newValue);
                            }}
                            showCounter={false}
                        />
                    </div>
                </Grid>
            )}
            {(selectedShape?.property === 'squares' ||
                selectedShape?.property === 'texts' ||
                selectedShape?.property === 'lines') && (
                <Grid item xs={6} md={6}>
                    <div className='d-flex align-items-center'>
                        <CustomTextField
                            id='txt_sp_width'
                            name='shapeWidth'
                            trans='width'
                            type='number'
                            value={shapeWidth}
                            disabled={
                                selectedShape?.property !== 'squares' &&
                                selectedShape?.property !== 'texts' &&
                                selectedShape?.property !== 'lines'
                            }
                            onChange={(e) => {
                                const max = 305;
                                let newValue = Number(e.target.value);
                                if (newValue > 305) {
                                    newValue = 305;
                                }
                                handleChangeProperty('width', newValue);
                            }}
                            showCounter={false}
                        />
                    </div>
                </Grid>
            )}
            {selectedShape !== null && (
                <Grid item xs={6} md={6}>
                    <div className='d-flex align-items-center'>
                        <CustomTextField
                            id='txt_sp_x'
                            name='shapeHorizontal'
                            trans='X'
                            type='number'
                            value={shapeHorizontal}
                            disabled={selectedShape === null}
                            onChange={(e) => {
                                const newValue = Number(e.target.value);
                                handleChangeProperty('x', newValue);
                            }}
                            showCounter={false}
                        />
                    </div>
                </Grid>
            )}
            {selectedShape !== null && (
                <Grid item xs={6} md={6}>
                    <div className='d-flex align-items-center'>
                        <CustomTextField
                            id='txt_sp_y'
                            name='shapeVertical'
                            trans='Y'
                            type='number'
                            value={shapeVertical}
                            disabled={selectedShape === null}
                            onChange={(e) => {
                                const newValue = Number(e.target.value);
                                handleChangeProperty('y', newValue);
                            }}
                            showCounter={false}
                        />
                    </div>
                </Grid>
            )}
            {(selectedShape?.property === 'squares' || selectedShape?.property === 'lines') && (
                <Grid item xs={6} md={6}>
                    <div className='d-flex align-items-center'>
                        <CustomTextField
                            id='txt_sp_corner_radius'
                            name='shapeCornerRadius'
                            trans='corner_radius'
                            type='number'
                            value={shapeCornerRadius}
                            disabled={selectedShape?.property !== 'squares' && selectedShape?.property !== 'lines'}
                            onChange={(e) => {
                                const newValue = Number(e.target.value);
                                handleChangeProperty('cornerRadius', newValue);
                            }}
                            showCounter={false}
                        />
                    </div>
                </Grid>
            )}

            {selectedShape?.property == 'ellipsis' && (
                <Grid item xs={6} md={6}>
                    <div className='d-flex align-items-center'>
                        <CustomTextField
                            id='txt_sp_radius'
                            name='shapeRadius'
                            trans='radius'
                            type='number'
                            value={shapeRadius}
                            disabled={selectedShape?.property !== 'ellipsis'}
                            onChange={(e) => {
                                const newValue = Number(e.target.value);
                                handleChangeProperty('radius', newValue);
                            }}
                            showCounter={false}
                        />
                    </div>
                </Grid>
            )}
            {(selectedShape?.property == 'squares' ||
                selectedShape?.property == 'ellipsis' ||
                selectedShape?.property == 'lines') && (
                <Grid item xs={6} md={6}>
                    <div className='d-flex align-items-center'>
                        <CustomTextField
                            id='txt_sp_stroke_width'
                            name='shapeStrokeWidth'
                            trans='stroke_width'
                            type='number'
                            value={shapeStrokeWidth}
                            disabled={
                                selectedShape?.property !== 'squares' &&
                                selectedShape?.property !== 'ellipsis' &&
                                selectedShape?.property !== 'lines'
                            }
                            onChange={(e) => {
                                const newValue = Number(e.target.value);
                                handleChangeProperty('strokeWidth', newValue);
                            }}
                            showCounter={false}
                        />
                    </div>
                </Grid>
            )}
        </div>
    );
};

export default ShapeProperties;
